import { render } from "./FilterItems.vue?vue&type=template&id=ade2aa9a&scoped=true"
import script from "./FilterItems.vue?vue&type=script&lang=js"
export * from "./FilterItems.vue?vue&type=script&lang=js"

import "./FilterItems.vue?vue&type=style&index=0&id=ade2aa9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ade2aa9a"

export default script